import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  RoleAction,
  RolePermissionSubject,
  ShiftTemplate,
} from '@wilson/interfaces';
import {
  CreateNewViaDragAndDropService,
  DragAndDropModeService,
} from '@wilson/shift-timeline/services';
import { ShiftTimelineUnassignedRegionState } from '@wilson/shift-timeline/state';
import { ShiftTemplateHelperService } from '../shift-template-drop-zone/shift-template-helper.service';
import { AbilityServiceSignal } from '@casl/angular';

@Component({
  selector: 'wilson-shift-quick-creation-from-template-card',
  templateUrl: './shift-quick-creation-from-template-card.component.html',
  styleUrls: ['./shift-quick-creation-from-template-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShiftQuickCreationFromTemplateCardComponent {
  private readonly store = inject(Store);
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  readonly createNewViaDragAndDropService = inject(
    CreateNewViaDragAndDropService,
  );
  private readonly shiftTemplateHelperService = inject(
    ShiftTemplateHelperService,
  );

  @Input() isQuickCreationCardOpen = true;

  public suggestedShiftTemplates$ = this.store.select(
    ShiftTimelineUnassignedRegionState.suggestedShiftTemplates,
  );

  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  startDrag(shiftTemplate: ShiftTemplate): void {
    this.shiftTemplateHelperService.setShiftTemplate(shiftTemplate);
    this.createNewViaDragAndDropService.setShiftTemplateDropZone(true);
    this.dragAndDropModeService.setDisplayTimeVisible(false);
    this.dragAndDropModeService.setDraggingItemId(
      CreateNewViaDragAndDropService.MOCK_SHIFT_ID,
    );
  }

  dragEnd(): void {
    this.createNewViaDragAndDropService.setShiftTemplateDropZone(false);
    this.dragAndDropModeService.setDraggingItemId(null);
  }
}
